import React from 'react'
import SetParentPasswordForm from '../Forms/SetParentPasswordForm';
import { useGlobalState } from '../../contexts/global';

const ModalSetParentPassword = () => {
    const { state, dispatch } = useGlobalState();
    const callback = state.modalProps.callback;

    return (
        <div className="modal-content">
            <h1 className="h-text-center">Nastavení rodičovského hesla</h1>
            <SetParentPasswordForm callback={callback} />
        </div>
    );
}

export default ModalSetParentPassword
